import { useMutation } from "@apollo/client";
import { faHeart, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import gql from "graphql-tag";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { curEpisodeVar } from "../apollo";
import { useMe } from "../hooks/useMe";
import { usePodcast } from "../hooks/usePodcast";
import {
  managePodcastQuery_getPodcastById_podcast,
  managePodcastQuery_getPodcastById_podcast_episodes,
} from "../__generated__/managePodcastQuery";
import { subscribePodcastMutation, subscribePodcastMutationVariables } from "../__generated__/subscribePodcastMutation";

const SUBSCRIBE_PODCAST_MUTATION = gql`
  mutation subscribePodcastMutation($subscribePodcastInput: SubscribePodcastInput!) {
    subscribePodcast(input: $subscribePodcastInput) {
      ok
    }
  }
`;

interface IParamsType {
  id: string;
}

export const Podcast = () => {
  const [subscribed, setSubscribed] = useState(false);
  const { data: meData } = useMe();
  const [tab, setTab] = useState("episodes");
  const [podcastId, setPodcastId] = useState("");
  const params = useParams<IParamsType>();
  const [queryReadyToStart, { data }] = usePodcast();

  const onCompleted = (data: subscribePodcastMutation) => {
    const {
      subscribePodcast: { ok },
    } = data;
    if (ok) {
      setSubscribed(!subscribed);
      console.log(subscribed);
    }
  };
  const [subscribePodcastMutation, { loading }] = useMutation<subscribePodcastMutation, subscribePodcastMutationVariables>(
    SUBSCRIBE_PODCAST_MUTATION,
    {
      onCompleted,
    }
  );

  const handleSubsribePodcast = () => {
    subscribePodcastMutation({
      variables: {
        subscribePodcastInput: {
          podcastId: +podcastId,
        },
      },
    });
  };

  useEffect(() => {
    setPodcastId(params.id);
    queryReadyToStart({
      variables: {
        input: {
          podcastId: +podcastId,
        },
      },
    });
    data?.getPodcastById.podcast?.subscribers?.forEach((subscriber) => {
      if (meData?.me && meData.me.id === subscriber.id) {
        setSubscribed(true);
      }
    });
  }, [params.id, podcastId, queryReadyToStart, data?.getPodcastById.podcast?.subscribers, meData?.me]);

  const hanldePlayEpisode = (
    podcast: managePodcastQuery_getPodcastById_podcast | null,
    episode: managePodcastQuery_getPodcastById_podcast_episodes
  ) => {
    curEpisodeVar({
      fileUrl: episode.fileUrl,
      title: podcast?.title + " - " + episode.title,
      podcastId: +podcastId,
      volume: 50,
    });
  };

  return (
    <div>
      <Helmet>
        <title>Podcast | Pocast</title>
      </Helmet>

      {!loading && (
        <div className="h-screen bg-black text-white">
          <div className="flex flex-col justify-center items-center text-center pt-10">
            <div className="w-full max-w-screen-sm px-5 text-center flex flex-col justify-between ">
              <div className="relative mb-2">
                <div className="relative mb-3 flex justify-between">
                  <div className="text-left text-3xl tracking-wider leading-10 pb-1 text-purple-700 ">Podcast</div>
                  {subscribed ? (
                    <button className="py-1 px-3 bg-pink-700 rounded-lg hover:bg-pink-800" onClick={handleSubsribePodcast}>
                      <FontAwesomeIcon icon={faHeart} className="mr-3" />
                      Subscribed
                    </button>
                  ) : (
                    <button className="py-1 px-3 bg-purple-800 rounded-lg hover:bg-purple-900" onClick={handleSubsribePodcast}>
                      Subscribe
                    </button>
                  )}
                </div>
                <div className="w-full bg-gray-700 flex mb-3 p-3 rounded-lg justify-between items-start ">
                  <div className="flex flex-col items-start">
                    <div className="text-xl text-black font-bold text-center tracking-wider mb-2">
                      {data?.getPodcastById.podcast?.title}
                    </div>
                    <div className="text-md text-gray-200 mb-2">
                      Total Episodes: {data?.getPodcastById.podcast?.episodes ? data?.getPodcastById.podcast.episodes.length : 0}
                    </div>
                    <div className=" text-md text-gray-200 mb-2">Rating: {data?.getPodcastById.podcast?.rating}</div>
                    <div className="  text-sm text-gray-300">Last updated: {data?.getPodcastById.podcast?.updatedAt}</div>
                  </div>
                </div>
              </div>
              <div className="h-0.5 w-full bg-gray-300 mb-2"></div>
              <div className="grid grid-cols-2 gap-2">
                <button
                  onClick={() => setTab("episodes")}
                  className={`p-2 rounded-lg bg-blue-700 ${tab === "episodes" ? "text-black bg-blue-900 font-bold" : ""}`}
                >
                  Episodes
                </button>
                <button
                  onClick={() => setTab("reviews")}
                  className={`p-2 rounded-lg bg-green-700 ${tab === "reviews" ? "text-black bg-green-900 font-bold" : ""}`}
                >
                  Reviews
                </button>
              </div>
              <div className="relative">
                {tab === "episodes" && (
                  <>
                    <div className="flex items-center justify-between w-full  mb-5">
                      <div className="text-left   text-purple-700 ">
                        <div className="text-xl tracking-wider leading-10">Episodes</div>
                        <div>
                          Total Episodes: {data?.getPodcastById.podcast?.episodes ? data?.getPodcastById.podcast.episodes.length : 0}
                        </div>
                      </div>
                    </div>
                    {data?.getPodcastById.podcast?.episodes &&
                      data.getPodcastById.podcast.episodes.map((episode) => (
                        <div key={episode.id} className="w-full bg-gray-700 flex mb-3 p-3 rounded-lg justify-between items-start ">
                          <div className="flex flex-col items-start">
                            <div className="font-bold text-xl text-black text-center tracking-wider mb-2">{episode.title}</div>
                            <div className="text-sm text-gray-300">Last updated: {episode.updatedAt}</div>
                          </div>
                          <button className="my-auto" onClick={() => hanldePlayEpisode(data?.getPodcastById.podcast, episode)}>
                            <FontAwesomeIcon icon={faPlay} />
                          </button>
                        </div>
                      ))}
                  </>
                )}
                {tab === "reviews" && (
                  <>
                    <div className="flex items-center justify-between w-full  mb-5">
                      <div className="text-left   text-purple-700 ">
                        <div className="text-xl tracking-wider leading-10">Reviews</div>
                        <div>Total Reviews: {data?.getPodcastById.podcast?.reviews ? data.getPodcastById.podcast.reviews.length : 0} </div>
                      </div>
                      <Link to={`/podcast/${podcastId}/write-review`} className="py-1 px-3 bg-purple-800 rounded-lg hover:bg-purple-900">
                        Write Review
                      </Link>
                    </div>
                    {data?.getPodcastById.podcast?.reviews &&
                      data.getPodcastById.podcast.reviews.map((review) => (
                        <div key={review.id} className="w-full bg-gray-700 flex mb-3 p-3 rounded-lg justify-between items-start ">
                          <div className="flex flex-col items-start">
                            <div className="text-sm text-gray-300  mb-2">Created: {review.createdAt}</div>
                            <div className="text-xl text-black text-center tracking-wider">{review.review}</div>
                          </div>
                          <div className="text-yellow-300 font-bold">{review.rating} / 5</div>
                        </div>
                      ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
